export default "__VITE_ASSET__2b_p_WQJ__"